import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import getAuthUserStorage from "../../helpers/getAuthUserStorage";

const useAuthUser = () => {
  // Get auth user storage data (already parsed by decryptData)
  const authUserStorage = getAuthUserStorage();

  // Listen to profile update status to trigger re-read of storage
  const { updateStatus } = useSelector((state) => ({
    updateStatus: state.Profile.updateStatus,
  }));

  // State
  const [userProfile, setUserProfile] = useState(
    authUserStorage ? authUserStorage?.userProfile : null
  );
  const [tenantProfile, setTenantProfile] = useState(
    authUserStorage ? authUserStorage?.tenant : null
  );
  const [roles, setRoles] = useState(
    authUserStorage ? authUserStorage?.roles : []
  );
  const [token, setToken] = useState(
    authUserStorage ? authUserStorage?.token : null
  );
  const [isSuperAdmin, setIsSuperAdmin] = useState(
    authUserStorage ? authUserStorage?.isSuperAdmin : false
  );
  const [isAdmin, setIsAdmin] = useState(
    authUserStorage ? authUserStorage?.isAdmin : false
  );

  useEffect(() => {
    // Get auth user storage data (already parsed by decryptData)
    const authUserStorage = getAuthUserStorage();

    // Update state
    setUserProfile(authUserStorage ? authUserStorage?.userProfile : null);
    setToken(authUserStorage ? authUserStorage?.token : null);
    setIsSuperAdmin(authUserStorage ? authUserStorage?.isSuperAdmin : false);
    setIsAdmin(authUserStorage ? authUserStorage?.isAdmin : false);
    setRoles(authUserStorage ? authUserStorage?.roles : []);
    setTenantProfile(authUserStorage ? authUserStorage?.tenant : null);
  }, [updateStatus]); // Re-read storage when profile update status changes

  return { userProfile, token, isSuperAdmin, isAdmin, roles, tenantProfile };
};

export default useAuthUser;
